module.exports = __webpack_public_path__ + "img/logo-search.e7e36d5d.jpg";